import { ITextQuestion } from '../models/feedback-form.model';
import clsx from 'clsx';

const TextQuestion = ({ question, value, onChange, onBlur }: {
    question: ITextQuestion;
    value?: string,
    onChange: (value: string) => void,
    onBlur: () => void
}) => {
    return (
        <div className="form-group">
            <label className={clsx("form-label", { required: question.isRequired })}>{question.title}</label>
            <input
                type="text"
                className="form-control form-control-sm" // Add Bootstrap classes for small form controls
                placeholder={question.title}
                required={question.isRequired}
                value={value || ''}
                onBlur={() => onBlur()}
                onChange={(e) => onChange(e.target.value)}
            />
        </div>
    )
};

export default TextQuestion;
